<!--
 * @Author: lbb lhz6887@163.com
 * @Date: 2024-07-03 10:52:07
 * @LastEditors: lbb lhz6887@163.com
 * @LastEditTime: 2024-07-22 09:32:53
 * @FilePath: \YHB_H5\src\pages\oneClickRegister\components\step01.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class='step-box'>
        <div class="step-content">
            <div class="step-title">上传银行卡卡号面照片 <span class="red">*</span></div>
            <div class="up-list">
                <UpImg :img="params.accountCardPic"
                    bgImg="https://yhb-pub.oss-cn-shenzhen.aliyuncs.com/YHB_H5/bankFont.png" type="accountCardPic"
                    txt="银行卡照片" @upload="uploadImg" />
                <UpImg :img="params.selfiePhoto"
                    bgImg="https://yhb-pub.oss-cn-shenzhen.aliyuncs.com/YHB_H5/faceFont.png" type="selfiePhoto"
                    txt="根据监管要求，请自拍一张您的照片" @upload="uploadImg" />
            </div>
            <div class="line"></div>
            <div class="step-title mt-15">请完善您的银行卡信息</div>
            <van-form ref="paramsForm" label-width="80px" :show-error="false" error-message-align="right"
                validate-first>
                <van-field v-model="params.accountCardName" clearable name="accountCardName" label="银行账户名"
                    placeholder="请输入" :rules="rule.accountCardName" />
                <van-field clearable v-model="params.accountCardNumber" name="accountCardNumber" label="银行卡号"
                    placeholder="请输入" :rules="rule.accountCardNumber" />
                <van-field readonly clickable name="accountCardBankName" :rules="rule.accountCardBankName"
                    :value="params.accountCardBankName" label="银行名称" placeholder="请选择支行" right-icon="arrow"
                    @click="bankShow = true" />
                <van-field clearable v-model="params.accountCardMobile" name="accountCardMobile" label="预留手机号"
                    placeholder="请输入" :rules="rule.accountCardMobile" />
            </van-form>
        </div>


        <div class="bom-tips">
            请务必确保您的结算卡为一类卡，否则可能影响资金结算
        </div>

        <Footer @giveup="giveup" @confirm="confirm" :step="2"  @back="goProstep" />

        <!-- 银行选择 -->
        <van-popup v-model="bankShow" position="bottom">
            <van-search v-model="queryBankName" show-action shape="round" placeholder="请输入搜索关键词" @search="onSearch">
                <template #action>
                    <div @click="onSearch">搜索</div>
                </template>
            </van-search>
            <div class="list">
                <van-list :finished="finished" finished-text="没有更多了" offset="20" @load="getMoreBank">
                    <!-- <van-cell v-for="item in bankList" :key="item.bankCode" :title="item.bankName" /> -->
                    <div class="bank-item" v-for="(item, index) in bankList" :key="index" @click="selectBank(item)">
                        {{ item.bankName }}
                    </div>
                </van-list>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { Toast } from 'vant';
import UpImg from "./uploadImg.vue"
import Footer from "./footer.vue"
import { bankCartDiscern, getBankList, merchSettle, faceRecognition } from "@/api/index"
export default {
    name: 'Step03',
    components: {
        UpImg,
        Footer
    },
    props: {
        merchartInfo: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    watch: {
        merchartInfo: {
            immediate: false,
            deep: true,
            handler(val) {
                Object.keys(this.params).forEach(key => {
                    this.params[key] = this.merchartInfo[key]
                });
            }
        }
    },
    data() {
        return {
            params: {
                accountCardPic: "", // 银行卡照片
                selfiePhoto: "", // 自拍照片
                accountCardName: "", // 银行账户名
                accountCardNumber: "", // 银行卡号
                accountCardBankName: "", // 银行名称
                accountCardBankCode: "", // 银卡银行编码
                accountCardMobile: "", // 银行预留手机号
                registerId: "", // 进件 ID
            },
            rule: {
                accountCardName: [{ required: true, message: '请输入银行账户名' }],
                accountCardNumber: [{ required: true, message: '请输入银行账户' }],
                accountCardBankName: [{ required: true, message: '请选择开户银行' }],
                accountCardMobile: [{ required: true, message: '请输入手机号' }],
            },
            bankList: [],
            bankShow: false,
            finished: false,
            loading: false,
            total: 0,
            num: 1,
            queryBankCode: "",
            queryBankName: "",

        };
    },
    created() {
        Object.keys(this.params).forEach(key => {
            this.params[key] = this.merchartInfo[key]
        });
        this.params.registerId = this.merchartInfo.id
        this.params.accountCardMobile = this.merchartInfo.mobile

        this.getBank()
    },
    methods: {
        // 图片上传
        uploadImg(file) {
            Toast.clear()
            this.params[file.type] = file.url
            if (file.type == "accountCardPic") {
                Toast.loading({
                    message: '识别中...',
                    forbidClick: true,
                });
                bankCartDiscern(file.url).then(res => {
                    if (res.code != 200) {
                        Toast.clear()
                        Toast(res.msg)
                        return
                    }
                    this.params.accountCardNumber = res.data.bankcardid
                    this.queryBankName = res.data.bankName
                    this.num = 1
                    this.getBank()
                    Toast.clear()
                })

            }
        },

        // 获取银行卡列表
        getBank() {
            getBankList(this.num, { bankCode: this.queryBankCode, bankName: this.queryBankName }).then(res => {
                this.num == 1 ? this.bankList = res.data.rows : this.bankList = [...this.bankList, ...res.data.rows]
                this.loading = false;
                if (this.bankList.lnegth >= res.data.total) this.finished = true
            })
        },

        // 获取更多银行卡列表
        getMoreBank() {
            this.num++;
            this.getBank()
        },

        // 搜索
        onSearch(e) {
            this.num = 1
            this.getBank()
        },

        // 选择银行卡
        selectBank(val) {
            this.params.accountCardBankCode = val.bankCode
            this.params.accountCardBankName = val.bankName
            this.bankShow = false
        },

        // 上一步
        goProstep() {
            this.$emit("goProstep", { step: 2 })
        },

        // 下一步
        async confirm() {
            // 触发表单的校验
            await this.$refs.paramsForm.validate().then(async () => {
                // 判断照片是否 已上传
                if (!this.params.accountCardPic) {
                    Toast(`请上传银行卡照片`);
                    return
                }
                if (!this.params.selfiePhoto) {
                    Toast(`请上自拍照片`);
                    return
                }

                // 校验表单是否有为空的内容
                if (!this.objIsNull(this.params)) {
                    Toast("请完整填写表单！")
                    return;
                }

                Toast.loading({
                    message: '提交中...',
                    forbidClick: true,
                    duration: "toast"
                });

                // 开心刷上游需要进行人脸识别  
                let faceData = {
                    idCardNumber: this.merchartInfo.idCardNumber,
                    image: this.params.selfiePhoto,
                    name: this.params.accountCardName
                }
                const faceRes = await faceRecognition(faceData)
                if (faceRes.code != 200) {
                    Toast.clear()
                    Toast(faceRes.msg)
                    return
                }

                merchSettle(this.params).then(res => {
                    if (res.code != 200) {
                        Toast(res.msg)
                        return;
                    }
                    this.$emit("confirm", { data: res.data, step: 2 })
                })
            }).catch(e => {
                Toast(`${e[0].message}`);
                return
            });
        },

        // 放弃注册
        giveup() {
            this.$emit("giveup")
        }
    },
};
</script>

<style scoped lang="scss">
.step-box {
    height: 100%;
    background-color: #fff;
}

::v-deep .van-cell {
    padding: 15px 5px;
    text-align: center;

    .van-field__control {
        text-align: right;
    }

    .van-radio-group {
        margin-right: -10px;
        justify-content: flex-end;
    }

    .van-field__control {

        .tips {
            width: 100%;
        }
    }
}

::v-deep .van-cell--borderless {
    padding: 10px;

    .van-field__control {
        text-align: left;
    }
}

.mt-15 {
    margin-top: 15px;
}

.up-list {
    width: 100%;
    display: inline-grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-row-gap: 20px;
    grid-column-gap: 20px;
    margin: 20px 0;
}

.line {
    height: 1px;
    background-color: #F2F2F2;
}

.van-popup {
    height: 300px;

    .list {
        max-height: 400px;

        .bank-item {
            padding: 15px;
            text-align: center;
            border-bottom: 1px solid #F2F2F2;
            font-size: 14px;
            color: #333333;
        }
    }
}

.van-search {
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    padding-right: 10px;
    z-index: 10;
}



.bom-tips {
    padding: 5px 15px;
    font-size: 12px;
    color: #D32537;
    background-color: #fff;
}
</style>